module.exports = __webpack_public_path__ + "static/media/georgia.b09282d3.woff";